import { Chain } from '@ew-did-registry/did';

// Volta chain
export const VOLTA_CHAIN_ID = 73799;
export const VOLTA_PUBLIC_RESOLVER_ADDRESS =
  '0x0a97e07c4Df22e2e31872F20C5BE191D5EFc4680';
export const VOLTA_RESOLVER_V1_ADDRESS =
  '0xf5EA22c1F799d425356c2aab2004200Ab4490D2b';
export const VOLTA_DOMAIN_NOTIFER_ADDRESS =
  '0xeea658026d6CDede4380D3aD030beAC911758A93';
export const VOLTA_ENS_REGISTRY_ADDRESS =
  '0xd7CeF70Ba7efc2035256d828d5287e2D285CD1ac';
export const VOLTA_CLAIM_MANAGER_ADDRESS =
  '0x5339adE9332A604A1c957B9bC1C6eee0Bcf7a031';
export const VOLTA_IDENTITY_MANAGER_ADDRESS =
  '0x84d0c7284A869213CB047595d34d6044d9a7E14A';
export const VOLTA_REWARD_POOL_ADDRESS =
  '0x6d832DDd386F1dFA53d5b0cACcFF509f95D345Ca';
export const VOLTA_RESOLVER_V2_ADDRESS =
  '0xcf72f16Ab886776232bea2fcf3689761a0b74EfE';
export const VOLTA_ERC_1056_ADDRESS =
  '0xc15d5a57a8eb0e1dcbe5d88b8f9a82017e5cc4af';
export const VOLTA_CLAIMS_REVOCATION_REG_ADDR =
  '0x9876d992D124f8E05e3eB35132226a819aaC840A';

// EWC chain
export const EWC_CHAIN_ID = 246;
export const EWC_CLAIM_MANAGER_ADDRESS =
  '0x23b026631A6f265d17CFee8aa6ced1B244f3920C';
export const EWC_ENS_REGISTRY_ADDRESS =
  '0x0A6d64413c07E10E890220BBE1c49170080C6Ca0';
export const EWC_RESOLVER_V2_ADDRESS =
  '0x70ad37DfeB1C05290F4bBd22188FA19Bc154A0ea';
export const EWC_PUBLIC_RESOLVER_ADDRESS =
  '0xA517983Bd4Af4DF0Ed9b52DA4BC405d0A95eE7E2';
export const EWC_DOMAIN_NOTIFER_ADDRESS =
  '0x5491Db3cC1f3AFf6C229e061735F92936004da3c';
export const EWC_IDENTITY_MANAGER_ADDRESS =
  '0x2d1569f3a2006d21c0dc60eb13c8557b63ce5a8d';
export const EWC_ADDRESS_1056 = '0xE29672f34e92b56C9169f9D485fFc8b9A136BCE4';
export const EWC_CLAIMS_REVOCATION_REG_ADDR =
  '0xd72B4c8D5B1a1A4C7085259548bDF1A175CFc48D';

export const chainIdToChainName = (chainId: number) => {
  switch (chainId) {
    case VOLTA_CHAIN_ID:
      return Chain.VOLTA;
    case EWC_CHAIN_ID:
      return Chain.EWC;
    case 1337: // test chain
      return Chain.VOLTA;
    default:
      throw new Error(`Unsupported chain ${chainId}`);
  }
};
